module.exports = __webpack_public_path__ + "static/pionoisedarkgrey-ab0aa6eb623944448ce1de2971e0e277.png";